export default {
  login: {
    title: 'تسجيل الدخول',
    error: {
      invalidEmail: 'بريد إلكتروني غير صالح',
      invalidPassword: 'كلمة مرور غير صالحة',
      badCredentialsTitle: 'بيانات اعتماد خاطئة',
      accountLockedTitle: 'تم حظر الوصول إلى الحساب',
      accountLockedCaption: 'يمكنك التواصل معنا عبر {contactEmail}',
      badCredentialsCaption: 'يرجى التحقق من بريدك الإلكتروني وكلمة المرور.',
      tooManyAttemptsRetryAfter: 'محاولات كثيرة جدًا. يرجى المحاولة مرة أخرى بعد {durationRemaining}.',
      tooManyAttempts: 'محاولات كثيرة جدًا. يرجى المحاولة لاحقًا.',
      unavailableIdentityProvider: 'طريقة التحقق هذه غير متوفرة حاليًا. يرجى المحاولة لاحقًا.'
    }
  },
  passwordRenewal: {
    title: 'تجديد كلمة المرور',
    newPassword: 'يمكنك الآن إدخال كلمة مرور جديدة لتسجيل الدخول',
    success: {
      title: 'تم تجديد كلمة المرور بنجاح',
      message: 'تم تعديل كلمة المرور المرتبطة بحسابك بنجاح. يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة.',
      redirect: 'سيتم توجيهك إلى الصفحة المطلوبة خلال بضع ثوانٍ.',
      redirectButton: 'التوجيه الفوري'
    },
    error: 'يجب أن تكون كلمة المرور الجديدة مختلفة عن القديمة'
  },
  forgotPassword: {
    title: 'إعادة تعيين كلمة المرور',
    subTitle: {
      email: 'يرجى إدخال عنوان بريدك الإلكتروني. ستتلقى رمزًا في بريدك الوارد يمكنك استخدامه لإعادة تعيين كلمة المرور.',
      sms: 'يرجى إدخال رقم هاتفك. ستتلقى رمزًا عبر رسالة نصية يتيح لك إعادة تعيين كلمة المرور'
    },
    useAnotherMethod: 'استخدام طريقة أخرى',
    chooseEmail: 'استلام رمز الاسترجاع عبر البريد الإلكتروني',
    chooseSms: 'استلام رمز الاسترجاع عبر رسالة نصية',
    newPassword: 'يمكنك الآن إدخال كلمة مرور جديدة لتسجيل الدخول',
    codeSent: {
      email: 'تم إرسال بريد إلكتروني يحتوي على الرمز الخاص بك. يرجى إدخاله في الحقول أدناه.',
      sms: 'تم إرسال رسالة نصية تحتوي على رمزك. يرجى إدخاله في الحقول أدناه'
    },
    waitBeforeRetry: 'يرجى الانتظار {timeRemaining} ثانية قبل المحاولة مرة أخرى.',
    tooManyTrials: 'لقد تجاوزت الحد المسموح به لمحاولات هذا الرمز. يرجى إعادة العملية.',
    success: {
      title: 'تم تغيير كلمة المرور بنجاح',
      message: 'تم تعديل كلمة المرور المرتبطة بحسابك بنجاح. يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة.',
      redirect: 'سيتم توجيهك إلى نموذج تسجيل الدخول خلال بضع ثوانٍ.'
    }
  },
  pendingStatus: {
    title: 'الحساب في انتظار التحقق',
    subTitle: 'يجب التحقق من هويتك قبل أن تتمكن من تسجيل الدخول.'
  },
  cgu: {
    label: 'الشروط والأحكام العامة للاستخدام',
    checkbox: 'لقد قرأت وأوافق على'
  },
  mfa: {
    title: 'التحقق بخطوتين',
    helper: 'لأسباب أمنية، يلزم التحقق بخطوتين للوصول إلى حسابك. يرجى اختيار وسيلة التحقق.',
    chooseMail: 'تلقي رمز تحقق على بريدك الإلكتروني',
    choosePhone: 'تلقي رمز تحقق عبر رسالة نصية إلى الرقم',
    smsSent: 'تم إرسال رسالة نصية تحتوي على رمزك إلى الرقم {userSms} . يرجى إدخاله في الحقول أدناه.',
    checkCode: 'تحقق من الرمز الخاص بي',
    codeNoSend: 'لم يتم استلام الرمز',
    dontAsk: 'عدم السؤال مرة أخرى على هذا الجهاز'
  },
  emailValidation: {
    title: 'التحقق من البريد الإلكتروني',
    resend: 'إعادة إرسال البريد الإلكتروني',
    emailSent: 'تم إرسال بريد إلكتروني يحتوي على رمزك إلى العنوان {userEmail} . يرجى إدخاله في الحقول أدناه.'
  },
  mobilePhoneValidation: {
    title: 'التحقق من رقم هاتفك',
    willSendCode: 'سنرسل لك رمز التحقق عن طريق رسالة نصية قصيرة للتأكد من أن الرقم لك.',
    numberChanged: 'لقد تم تغيير رقم الهاتف المستخدم للاتصال. هذا هو الرقم الذي تم إدخاله:',
    codeSent: 'تم إرسال رمز SMS إليك للتحقق من صحته. يرجى إدخاله أدناه.',
    checkPhoneNumber: 'إذا كان هذا الرقم لا يتوافق مع رقم هاتفك الحالي، يمكنك تغييره.',
    updateMobilePhone: 'تغيير رقم هاتفي',
    invalidPhoneNumber: 'رقم الهاتف غير صالح'
  },
  lockAccount: {
    lock: 'قفل حسابي',
    warning: 'أنت على وشك قفل حسابك. المتابعة؟',
    resend: 'إعادة إرسال البريد الإلكتروني',
    locked: 'تم قفل الحساب. سيتم تسجيل خروجك.'
  },
  register: {
    title: 'التسجيل',
    subTitle: 'نموذج التسجيل',
    subTitlePatient: 'نموذج تسجيل المريض',
    createNewAccount: 'إنشاء حساب جديد',
    passwordConfirm: 'تأكيد كلمة المرور',
    action: 'تسجيل',
    registerAs: 'التسجيل كـ',
    error: {
      passwordConfirm: 'يجب أن تتطابق كلمات المرور',
      emailAlreadyUsed: 'هذا البريد الإلكتروني مستخدم بالفعل'
    },
    confirmation: {
      success: {
        title: 'تم التسجيل بنجاح',
        message: 'تم إنشاء حسابك بنجاح. يمكنك الآن تسجيل الدخول.',
        redirect: 'سيتم توجيهك إلى نموذج تسجيل الدخول خلال بضع ثوانٍ.'
      },
      error: {
        title: 'فشل التسجيل',
        message: 'حدث خطأ أثناء التسجيل. يرجى المحاولة لاحقًا.'
      }
    }
  },
  code: {
    sent: 'تم إرسال رمز جديد',
    incorrect: 'رمز خاطئ',
    expired: 'انتهت صلاحية الرمز.',
    invalid: 'الرمز غير صالح',
    alreadySent: 'تم إرسال رمز بالفعل مؤخراً'
  },
  errors: {
    sessionExpired: {
      title: 'انتهت صلاحية الجلسة'
    },
    expiredLink: 'انتهت صلاحية ارتباط الاتصال.'
  },
  firstLogin: {
    title: 'يرجى تحديد كلمة المرور الخاصة بك',
    welcome: 'أهلاً وسهلاً بك!',
    pendingLogin: 'جاري تسجيل الدخول إلى حسابك...',
    resendCode: 'لم تستلم الرمز الخاص بك',
    newPassword: 'يمكنك الآن إدخال كلمة المرور الخاصة بتسجيل الدخول',
    success: {
      success: 'اتصال ناجح!',
      title: 'تم إنشاء كلمة المرور بنجاح',
      message: 'تم إنشاء كلمة المرور المرتبطة بحسابك بنجاح. يمكنك الآن تسجيل الدخول باستخدام كلمة المرور هذه.',
      redirect: 'سيتم توجيهك إلى نموذج تسجيل الدخول خلال بضع ثوانٍ.',
      redirectBack: 'سيتم توجيهك إلى الصفحة المطلوبة خلال بضع ثوانٍ.'
    },
    error: {
      codeResent: 'يرجى إدخال رمز الأمان الذي أرسلناه لك عبر البريد الإلكتروني لتسجيل الدخول.'
    }
  },
  biometrics: {
    login: {
      backToNormalLogin: 'تسجيل الدخول العادي'
    },
    error: {
      biometricsErrorCaptions: 'حدث خطأ أثناء التحقق',
      biometricsKeyInvalidated: 'بياناتك البيومترية منتهية الصلاحية. يلزم تسجيل جديد.'
    },
    enroll: {
      enrollSuccessCaption: 'تمت إضافة تسجيل الدخول باستخدام البيانات البيومترية',
      enrollErrorCaption: 'حدثت مشكلة أثناء تسجيل البيانات البيومترية',
      warning: 'بتفعيل تسجيل الدخول باستخدام البيانات البيومترية، فإنك توافق على أن جميع البصمات المسجلة على هذا الجهاز تتيح الوصول إلى ملفك الشخصي وبياناتك الشخصية.',
      identificationText: 'التعرف بواسطة',
      askQuestionPartOne: 'هل ترغب في استخدام التحقق بواسطة ',
      askQuestionPartTwo: ' لتسجيل الدخول المستقبلي؟'
    }
  }
}
